// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"R2-z","dimensionLabel":"S2-z","styleChooserControlWrapper":"T2-z","styleChooserControl":"U2-z","disabled":"V2-z","giftCard":"W2-z","styleChooserText":"X2-z"};